<fieldset class="fieldGroup">
  <legend>{{ title() }}</legend>
  @if (coilResponse().TotalCapacity) {
    <div class="detailRow">
      <label class="displayLabel">Total Capacity:</label>
      <label class="displayValue">{{ coilResponse().TotalCapacity }}</label>
      <label class="configurationRatingUnitLabel">{{ getCapacityUnits() }}</label>
    </div>
  }
  @if (coilResponse().SensibleCapacity) {
    <div class="detailRow">
      <label class="displayLabel">Sensible Capacity:</label>
      <label class="displayValue">{{ coilResponse().SensibleCapacity }}</label>
      <label class="configurationRatingUnitLabel">{{ getCapacityUnits() }}</label>
    </div>
  }
  @if (coilResponse().NumberOfCircuits) {
    <div class="detailRow">
      <label class="displayLabel">Coil Circuits:</label>
      <label class="displayValue">{{ coilResponse().NumberOfCircuits }}</label>
      <label class="configurationRatingUnitLabel"></label>
    </div>
  }
  <div class="detailRow">
    <label class="displayLabel">Dry Bulb:</label>
    <label class="displayValue">{{ coilResponse().LeavingDryBulbTemperature }}</label>
    <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
  </div>
  @if (coilResponse().LeavingWetBulbTemperature) {
    <div class="detailRow">
      <label class="displayLabel">Wet Bulb:</label>
      <label class="displayValue">{{ coilResponse().LeavingWetBulbTemperature }}</label>
      <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
    </div>
  }
  @if (coilResponse().FluidFlowRate) {
    <div class="detailRow">
      <label class="displayLabel">Flow Rate:</label>
      <label class="displayValue">{{ coilResponse().FluidFlowRate }}</label>
      <label class="configurationRatingUnitLabel">{{ getFlowRateUnits() }}</label>
    </div>
  }
  @if (coilResponse().FluidTemperatureChange) {
    <div class="detailRow">
      <label class="displayLabel">Fluid Temp Change:</label>
      <label class="displayValue">{{ coilResponse().FluidTemperatureChange }}</label>
      <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
    </div>
  }
  @if (coilResponse().LeavingFluidTemperature) {
    <div class="detailRow">
      <label class="displayLabel">Leaving Fluid Temp:</label>
      <label class="displayValue">{{ coilResponse().LeavingFluidTemperature }}</label>
      <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
    </div>
  }
  @if (!isSureflow() && coilResponse().FluidPressureDrop) {
    <div class="detailRow">
      <label class="displayLabel">Fluid Pressure Drop:</label>
      <label class="displayValue">{{ coilResponse().FluidPressureDrop }}</label>
      <label class="configurationRatingUnitLabel">{{ getPressureDropUnits() }}</label>
    </div>
  }
</fieldset>
